import React from 'react';
import { Button } from '@components';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useLocation, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Get, Put } from '@app/utils/httpProvider';
import { useQuery, useMutation } from 'react-query';
import { TINH_API } from '@app/utils/apiUrl.js';
import { messageToast, status200, status201 } from '@app/utils/define';

const schema = yup.object().shape({
    maTinh: yup
        .number()
        .typeError('Mã tỉnh/thành phố phải là số nguyên')
        .integer('Mã tỉnh/thành phố phải là số nguyên')
        .positive('Mã tỉnh/thành phố phải lớn hơn 0')
        .required('Mã tỉnh/thành phố không được để trống'),
    tenTinh: yup.string().trim().required('Tên tỉnh/thành phố không được để trống')
});

const TinhEdit = () => {
    const history = useHistory();
    const location = useLocation();
    const paramUrl = new URLSearchParams(location.search.substring(1));
    const itemId = paramUrl.get('id');

    const itemEdit = useQuery([itemId], () => Get(TINH_API.GET_ITEM, itemId), {
        enabled: !!itemId
    });
    const editFunc = useMutation((value) => Put(TINH_API.UPDATE_ITEM, itemId, value));

    const handleEdit = async (values) => {
        const payload = {
            maTinh: Number(values.maTinh),
            tenTinh: values.tenTinh.trim()
        };

        editFunc.mutate(payload, {
            onSuccess: (res) => {
                if (res && (res.status === status200 || res.status === status201)) {
                    toast.success(messageToast.messageToastUpdateSuccess);
                    history.goBack();
                } else {
                    toast.error(messageToast.messageToastUpdateError);
                }
            },
            onError: (err) => {
                toast.error(err?.message || 'Đã có lỗi xảy ra, vui lòng thử lại!');
            }
        });
    };

    if (itemEdit.isLoading) {
        return <div>Đang tải...</div>;
    }

    if (itemEdit.isError) {
        return <div>Có lỗi xảy ra: {itemEdit.error?.message}</div>;
    }

    if (!itemEdit.data) {
        return <div>Không tìm thấy tỉnh / thành phố.</div>;
    }

    return (
        <Card>
            <Card.Header as="h5">Sửa tỉnh / thành phố</Card.Header>
            <Card.Body>
                <Formik
                    enableReinitialize
                    validationSchema={schema}
                    onSubmit={(values) => handleEdit(values)}
                    initialValues={{
                        maTinh: itemEdit.data.maTinh ?? itemEdit.data.MaTinh ?? '',
                        tenTinh: itemEdit.data.tenTinh || itemEdit.data.TenTinh || ''
                    }}
                >
                    {({ handleSubmit, handleChange, values, errors }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Mã tỉnh / TP <span className="text-danger">*</span>
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        placeholder="Nhập mã tỉnh / thành phố"
                                        type="number"
                                        name="maTinh"
                                        value={values.maTinh}
                                        onChange={handleChange}
                                        isInvalid={!!errors.maTinh}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.maTinh}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Tên tỉnh / TP <span className="text-danger">*</span>
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        placeholder="Nhập tên tỉnh / thành phố"
                                        type="text"
                                        name="tenTinh"
                                        value={values.tenTinh}
                                        onChange={handleChange}
                                        isInvalid={!!errors.tenTinh}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.tenTinh}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                <Col md={{ span: 10, offset: 2 }}>
                                    <ButtonGroup>
                                        <Button type="submit" theme="primary" disabled={editFunc.isLoading}>
                                            Lưu
                                        </Button>
                                        <Button
                                            type="button"
                                            theme="secondary"
                                            onClick={() => history.goBack()}
                                        >
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
            </Card.Body>
        </Card>
    );
};

export default TinhEdit;
